/* @flow */
import { sortBy, clone } from 'lodash';
import Collection from 'lib/Collection';
import apiRequest from 'lib/apiRequest';
import Message from 'entities/Message';
import jstz from 'jstimezonedetect';

class Messages extends Collection {
  initialize() {
    this.model = Message;
  }

  comparator(a: Message, b: Message) {
    return b.getSeq() - a.getSeq();
  }

  getReverseArray() {
    const modelsCopy = clone(this.models);
    return sortBy(modelsCopy, (message) => message.getSeq());
  }
  // XXX (rgoldfinger) remove when cleaning up old way of sending messages
  static yieldMessagesForGroupId(groupId, options = {}) {
    return apiRequest(`/classes/${groupId}/messages`, 'GET', options)
      .then(_handleMessageResponse);
  }
  // XXX (rgoldfinger) remove when cleaning up old way of sending messages
  static yieldScheduledMessagesForGroupId(groupId, options = {}) {
    return apiRequest(`/classes/${groupId}/messages/scheduled`, 'GET', options)
      .then(_handleMessageResponse);
  }

  static yieldThreadMessagesForGroupId(groupId, threadUuid: string, options = {}) {
    return apiRequest(`/classes/${groupId}/threads/${threadUuid}/messages`, 'GET', options)
      .then(_handleMessageResponse);
  }

  static yieldScheduledThreadMessagesForGroupId(groupId, threadUuid: string, options = {}) {
    return apiRequest(`/classes/${groupId}/threads/${threadUuid}/messages/scheduled`,
      'GET', options)
      .then(_handleMessageResponse);
  }

  static export(groupIds, since, until) {
    const tz = jstz.determine();
    const timezone = tz.name();

    return apiRequest('/messages/export', 'POST', {
      group_ids: groupIds,
      since,
      until,
      time_zone: timezone,
    });
  }
}

function _handleMessageResponse(response) {
  const messages = new Messages();
  if (response.messages) {
    response.messages.forEach(messageJSON => {
      messages.add(Message.fromJSON(messageJSON));
    });
  }
  return messages;
}

export default Messages;



// WEBPACK FOOTER //
// ./src/collections/Messages.js